import convertCurrencyFormat from '@zola-helpers/client/dist/es/util/convertCurrencyFormat';

function getPrecision(dollarAmount: number) {
  const hasCents = dollarAmount % 1 !== 0;
  return hasCents ? 2 : 0;
}

/** Format a price as a USD currency string */
export function priceFormatter(priceInDollars?: number): string {
  if (!priceInDollars) return '';

  // Use don't show decimals for integer prices
  const minimumFractionDigits = getPrecision(priceInDollars);

  return convertCurrencyFormat(priceInDollars, 'USD', minimumFractionDigits, 2);
}
